/**
 * Отслеживание электронной коммерции (Enhanced Ecommerce) -> dataLayer.
 * Глобальные функции для совместимости со старыми вызовами Аспро.
 */
if (typeof window.EcommerceTracker === 'undefined') {
    window.EcommerceTracker = class EcommerceTracker {
        constructor() {
            window.dataLayer = window.dataLayer || [];
            this.exposeGlobals();
        }

        logError(methodName, error) {
            console.error(`[EcommerceTracker.${methodName}]`, error);
        }

        // Регистрация глобальных функций Аспро в window
        exposeGlobals() {
            window.checkCounters = this.safeCheckCounters.bind(this);
            window.addBasketCounter = this.safeAddBasketCounter.bind(this);
            window.purchaseCounter = this.safePurchaseCounter.bind(this);
            window.viewItemCounter = this.safeViewItemCounter.bind(this);
            window.delFromBasketCounter = this.safeDelFromBasketCounter.bind(this);
            window.checkoutCounter = this.safeCheckoutCounter.bind(this);
        }

        getCounters() {
            return window.arNextOptions.COUNTERS;
        }

        getSiteDir() {
            return window.arNextOptions.SITE_DIR;
        }

        getEvents() {
            return this.getCounters().GOOGLE_EVENTS;
        }

        // Проверка активности счетчиков
        checkCounters(name) {
            const counters = this.getCounters();

            if (typeof name !== 'undefined') {
                if (name === 'google') {
                    return counters.GOOGLE_ECOMERCE === 'Y' && counters.GOOGLE_COUNTER > 0;
                }

                if (name === 'yandex') {
                    return counters.YANDEX_ECOMERCE === 'Y' && counters.YANDEX_COUNTER > 0;
                }

                return false;
            }

            return (
                (counters.YANDEX_ECOMERCE === 'Y' && counters.YANDEX_COUNTER > 0) ||
                (counters.GOOGLE_ECOMERCE === 'Y' && counters.GOOGLE_COUNTER > 0)
            );
        }

        safeCheckCounters(name) {
            try {
                return this.checkCounters(name);
            } catch (error) {
                this.logError('checkCounters', error);
                return false;
            }
        }

        waitDataLayer(callback) {
            if (typeof window.dataLayer !== 'undefined') {
                callback();
                return;
            }

            window.setTimeout(() => {
                this.waitDataLayer(callback);
            }, 100);
        }

        // Запрос данных о товаре/заказе через ajax/goals.php
        fetchGoals(payload) {
            return window
                .fetch(`${this.getSiteDir()}ajax/goals.php`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: new URLSearchParams(payload),
                })
                .then((response) => response.json());
        }

        mapBasketProducts(items) {
            const products = [];

            for (const key in items) {
                const row = items[key];
                products.push({
                    id: row.ID,
                    sku: row.ID,
                    name: row.NAME,
                    price: row.PRICE,
                    brand: row.BRAND,
                    category: row.CATEGORY,
                    quantity: row.QUANTITY,
                });
            }

            return products;
        }

        // Добавление в корзину (addToCart)
        addBasketCounter(id) {
            if (this.getCounters().USE_BASKET_GOALS !== 'N') {
                window.BX.onCustomEvent('onCounterGoals', [{goal: 'goal_basket_add', params: {id}}]);
            }

            return this.fetchGoals({ID: id}).then((item) => {
                this.waitDataLayer(() => {
                    window.dataLayer.push({
                        event: this.getEvents().ADD2BASKET,
                        ecommerce: {
                            currencyCode: item.CURRENCY,
                            add: {
                                products: [
                                    {
                                        id: item.ID,
                                        name: item.NAME,
                                        price: item.PRICE,
                                        brand: item.BRAND,
                                        category: item.CATEGORY,
                                        quantity: item.QUANTITY,
                                    },
                                ],
                            },
                        },
                    });
                });
            });
        }

        safeAddBasketCounter(id) {
            try {
                const request = this.addBasketCounter(id);
                if (request && typeof request.catch === 'function') {
                    request.catch((error) => this.logError('addBasketCounter', error));
                }
            } catch (error) {
                this.logError('addBasketCounter', error);
            }
        }

        // Оформление заказа (purchase)
        purchaseCounter(orderId, type, callback) {
            return this.fetchGoals({ORDER_ID: orderId, TYPE: type}).then((order) => {
                const products = this.mapBasketProducts(order.ITEMS);

                this.waitDataLayer(() => {
                    const ecommerce = {
                        purchase: {
                            actionField: {
                                id: order.ACCOUNT_NUMBER,
                                shipping: order.PRICE_DELIVERY,
                                tax: order.TAX_VALUE,
                                list: type,
                                revenue: order.PRICE,
                            },
                            products,
                        },
                    };

                    window.dataLayer.push({
                        event: this.getEvents().PURCHASE,
                        ecommerce,
                    });

                    callback(ecommerce);
                });
            });
        }

        safePurchaseCounter(orderId, type, callback) {
            const done = typeof callback === 'function' ? callback : function () {};

            try {
                const request = this.purchaseCounter(orderId, type, done);
                if (request && typeof request.catch === 'function') {
                    request.catch((error) => {
                        this.logError('purchaseCounter', error);
                        done();
                    });
                }
            } catch (error) {
                this.logError('purchaseCounter', error);
                done();
            }
        }

        // Просмотр карточки товара (detail)
        viewItemCounter(id, priceId) {
            return this.fetchGoals({PRODUCT_ID: id, PRICE_ID: priceId}).then((item) => {
                this.waitDataLayer(() => {
                    window.dataLayer.push({
                        ecommerce: {
                            detail: {
                                products: [
                                    {
                                        id: item.ID,
                                        name: item.NAME,
                                        price: item.PRICE,
                                        brand: item.BRAND,
                                        category: item.CATEGORY,
                                    },
                                ],
                            },
                        },
                    });
                });
            });
        }

        safeViewItemCounter(id, priceId) {
            try {
                const request = this.viewItemCounter(id, priceId);
                if (request && typeof request.catch === 'function') {
                    request.catch((error) => this.logError('viewItemCounter', error));
                }
            } catch (error) {
                this.logError('viewItemCounter', error);
            }
        }

        // Удаление из корзины (removeFromCart)
        delFromBasketCounter(id, callback = function () {}) {
            return this.fetchGoals({ID: id}).then((item) => {
                this.waitDataLayer(() => {
                    window.dataLayer.push({
                        event: this.getEvents().REMOVE_BASKET,
                        ecommerce: {
                            remove: {
                                products: [
                                    {
                                        id: item.ID,
                                        name: item.NAME,
                                        category: item.CATEGORY,
                                    },
                                ],
                            },
                        },
                    });

                    callback();
                });
            });
        }

        safeDelFromBasketCounter(id, callback) {
            const done = typeof callback === 'function' ? callback : function () {};

            try {
                const request = this.delFromBasketCounter(id, done);
                if (request && typeof request.catch === 'function') {
                    request.catch((error) => {
                        this.logError('delFromBasketCounter', error);
                        done();
                    });
                }
            } catch (error) {
                this.logError('delFromBasketCounter', error);
                done();
            }
        }

        // Переход к оформлению заказа (checkout)
        checkoutCounter(step, option) {
            return this.fetchGoals({BASKET: 'Y'}).then((basket) => {
                const products = this.mapBasketProducts(basket.ITEMS);

                this.waitDataLayer(() => {
                    window.dataLayer.push({
                        event: this.getEvents().CHECKOUT_ORDER,
                        ecommerce: {
                            checkout: {
                                actionField: {
                                    step,
                                    option,
                                },
                                products,
                            },
                        },
                    });
                });
            });
        }

        safeCheckoutCounter(step, option) {
            try {
                const request = this.checkoutCounter(step, option);
                if (request && typeof request.catch === 'function') {
                    request.catch((error) => this.logError('checkoutCounter', error));
                }
            } catch (error) {
                this.logError('checkoutCounter', error);
            }
        }
    };
}

try {
    new window.EcommerceTracker();
} catch (error) {
    console.error('[EcommerceTracker.init]', error);
}
